import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    SnackbarComponent,
    SnackbarData,
} from '@intranet/shared/snackbar/snackbar.component';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
    constructor(private _snackBar: MatSnackBar) {}

    success(message: string, duration = 5000): void {
        this._open({ message, type: 'success' }, duration);
    }

    error(message: string, duration = 6000): void {
        this._open({ message, type: 'error' }, duration);
    }

    private _open(data: SnackbarData, duration: number): void {
        this._snackBar.openFromComponent(SnackbarComponent, {
            data,
            duration,
        });
    }
}
